module.exports = __webpack_public_path__ + "img/flecha-atras-blanca.78651163.png";